// Copyright (c) 2026 by Audere

import { SxProps, Theme } from "@mui/material";

export type StyleSheet = Record<string, SxProps<Theme>>;

export const createStyleSheet = (styles: StyleSheet) => styles;

export const logoColors = {
  continent: "#130026",
  circles: "#E82626",
  wires: "#C1C1C1",
};

export const globalStyles = createStyleSheet({
  pageContainerRow: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  gapTop: {
    marginTop: 2,
  },
});
